<template>
	<div
		class="absolute z-20 flex size-12 cursor-pointer items-center justify-center rounded-full bg-black/20 p-2 shadow-lg"
		:class="containerClass"
	>
		<slot />
	</div>
</template>

<script setup lang="ts">
import type { FloatingButtonProps } from '.';

defineProps<FloatingButtonProps>();
</script>
